/* wellinda-clinically — tab switching for "Choose Your Daily Support".
   Self-contained: only touches elements inside its own section. */
(function () {
  'use strict';

  function init(root) {
    var tabs = root.querySelectorAll('[data-wclin-tab]');
    var panels = root.querySelectorAll('[data-wclin-panel]');
    if (!tabs.length) return;

    function show(id) {
      for (var i = 0; i < tabs.length; i++) {
        var active = tabs[i].getAttribute('data-wclin-tab') === id;
        tabs[i].classList.toggle('is-active', active);
        tabs[i].setAttribute('aria-selected', String(active));
      }
      for (var j = 0; j < panels.length; j++) {
        var on = panels[j].getAttribute('data-wclin-panel') === id;
        panels[j].classList.toggle('is-active', on);
        if (on) panels[j].removeAttribute('hidden');
        else panels[j].setAttribute('hidden', 'hidden');
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function () {
        show(this.getAttribute('data-wclin-tab'));
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wclin]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // the theme editor re-renders sections on edit
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wclin]');
    if (root) init(root);
  });
})();
